module.exports = __webpack_public_path__ + "img/图0@2x.bb3cdd3f.png";